<div class="modal-header">
    <h4 class="modal-title pull-left">Modifica rifornimento ID {{ refillId }}</h4>
    <button type="button" class="btn-close close pull-right" aria-label="Close" (click)="bsModalRef.hide()">
        <span aria-hidden="true" class="visually-hidden">&times;</span>
    </button>
</div>
<form [formGroup]="updateRefillForm" (ngSubmit)="onUpdateRefillSubmit()">
    <div class="modal-body">
        <div class="error-box my-3" [hidden]="errorMessage.length < 1">
            <strong>{{errorMessage}}</strong>
        </div>
        <div class="my-3">
            Liv carburante:
            <rating [max]="5" formControlName="fuel_level" [customTemplate]="levelsCarburante"
                (ngModelChange)="onAnyValueChange($event)"></rating>
            <ng-template #levelsCarburante let-i="index" let-v="value">
                <button type="button" class="btn btn-{{i < v ? 'alert' : 'default'}}">
                    {{i == 0 ? '&#48;' : ''}}
                    {{i == 1 ? '&#188;' : ''}}
                    {{i == 2 ? '&#189;' : ''}}
                    {{i == 3 ? '&#190;' : ''}}
                    {{i == 4 ? '&#49;' : ''}}
                </button>
            </ng-template>
        </div>
        <div class="form-group my-3">
            <div class="input-group">
                <div class="input-group-prepend">
                    <span class="input-group-text">Lt</span>
                </div>
                <input type="number" formControlName="quantity" placeholder="Quantità litri" class="form-control"
                    [class.is-invalid]="modelSubmitted && getRefillFormControls.quantity.errors"
                    (ngModelChange)="onAnyValueChange($event)">
                <div *ngIf="modelSubmitted && getRefillFormControls.quantity.errors" class="invalid-feedback">
                    <div *ngIf="getRefillFormControls.quantity.errors.required">
                        Quantità è un campo obbligatorio
                    </div>
                    <div *ngIf="getRefillFormControls.quantity.errors.minlength">
                        Non può essere 0
                    </div>
                </div>
            </div>
        </div>
        <div class="form-group my-3">
            <div class="input-group">
                <div class="input-group-prepend">
                    <span class="input-group-text">€</span>
                </div>
                <input type="number" formControlName="amount" placeholder="Spesa in euro" class="form-control"
                    [class.is-invalid]="modelSubmitted && getRefillFormControls.amount.errors"
                    (ngModelChange)="onAnyValueChange($event)">
                <div *ngIf="modelSubmitted && getRefillFormControls.amount.errors" class="invalid-feedback">
                    <div *ngIf="getRefillFormControls.amount.errors.required">
                        Spesa è un campo obbligatorio
                    </div>
                    <div *ngIf="getRefillFormControls.amount.errors.minlength">
                        Non può essere 0
                    </div>
                </div>
            </div>
        </div>
        <div class="form-group my-3">
            <div class="input-group">
                <div class="input-group-prepend">
                    <span class="input-group-text">Km</span>
                </div>
                <input type="number" formControlName="km" placeholder="Kilometri attuali" class="form-control"
                    [class.is-invalid]="modelSubmitted && getRefillFormControls.km.errors"
                    (ngModelChange)="onAnyValueChange($event)" />
                <div *ngIf="modelSubmitted && getRefillFormControls.km.errors" class="invalid-feedback">
                    <div *ngIf="getRefillFormControls.km.errors.required">
                        KM è un campo obbligatorio
                    </div>
                    <div *ngIf="getRefillFormControls.km.errors.minlength">
                        Non può essere 0
                    </div>
                    <div *ngIf="getRefillFormControls.km.errors.maxlength">
                        Troppo lungo
                    </div>
                </div>
            </div>
        </div>
        <div class="input-group my-3" *ngIf="made_at !== undefined">
            <div class="input-group-prepend">
                <span class="input-group-text" id="basic-addon15">Data e ora</span>
            </div>
            <input type="text" class="form-control" #dp="bsDatepicker" style="height: auto;" bsDatepicker
                [bsConfig]="{ dateInputFormat: 'D/MM/YYYY', showWeekNumbers: false }" [(ngModel)]="made_at"
                [ngModelOptions]="{standalone: true}" (bsValueChange)="onAnyValueChange($event)">
            <timepicker [(ngModel)]="made_at" [ngModelOptions]="{standalone: true}" [showMeridian]="false"
                (change)="onAnyValueChange($event)"></timepicker>
        </div>
        <div class="img-container my-3" [hidden]="willUserEditBox">
            <p><em>Foto cruscotto</em></p>
            <img [src]="fotoBoxBlob">
            <button type="button" class="btn btn-primary mt-1" (click)="changeBoxFotoOnClick()">Cambia foto
                cruscotto</button>
        </div>
        <div [hidden]="!willUserEditBox">
            <div [hidden]="box_url64" class="my-3">
                <div class="custom-file">
                    <input type="file" accept="image/*" class="custom-file-input" id="fsLoadImageBox" size="24"
                        (change)="imageBoxLoaded($event)">
                    <label class="custom-file-label" for="fsLoadImageBox">Carica foto cruscotto da libreria...</label>
                </div>
            </div>
            <div [hidden]="!box_url64" class="img-container my-3">
                <canvas id="cnvsBox" class="canvas_recive"></canvas>
                <button type="button" (click)="deletePicBox()" class="btn btn-primary btn-block">
                    <span class="oi oi-circle-x"></span>Scarta foto a cruscotto
                </button>
            </div>
        </div>
        <div class="img-container my-3" [hidden]="willUserEditRecit">
            <p><em>Foto ricevuta</em></p>
            <img [src]="fotoReciveBlob">
            <button type="button" class="btn btn-primary mt-1" (click)="changeRecitFotoOnClick()">Cambia foto
                ricevuta</button>
        </div>
        <div [hidden]="!willUserEditRecit">
            <div [hidden]="recive_url64" class="my-3">
                <div class="custom-file">
                    <input type="file" accept="image/*" class="custom-file-input" id="fsLoadImageRec" size="24"
                        (change)="imageRecLoaded($event)">
                    <label class="custom-file-label" for="fsLoadImageRec">Carica foto ricevuta da libreria...</label>
                </div>
            </div>
            <div [hidden]="!recive_url64" class="img-container my-3">
                <canvas id="cnvsRec" class="canvas_recive"></canvas>
                <button type="button" (click)="deletePicRecive()" class="btn btn-primary btn-block">
                    <span class="oi oi-circle-x"></span> Scarta foto a ricevuta
                </button>
            </div>
        </div>
        <div class="error-box my-3" [hidden]="saveChangesErrorMessage.length < 1">
            <strong>{{saveChangesErrorMessage}}</strong>
        </div>
    </div>
    <div class="modal-footer">
        <button type="button" class="btn btn-secondary" (click)="bsModalRef.hide()">
            Anulla modifiche
        </button>
        <button type="submit" class="btn btn-primary" [disabled]="shouldDisableSubmit()">
            Effettua modifiche
        </button>
    </div>
</form>